export const STORE_PREFIX = 'process/sportmaster/'
